import { BeforeAfterSlider } from "./BeforeAfterSlider";

export function OurWorkSection() {
  return (
    <section className="py-20 md:py-32 bg-secondary/20">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-6">
            Unsere Arbeit: Vorher & Nachher
          </h2>
          <p className="text-lg text-muted-foreground">
            Machen Sie sich selbst ein Bild von unserer Arbeit. Wir verwandeln
            vollgestellte Räume in besenreine, übergabefertige Objekte.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <BeforeAfterSlider
            beforeImage="https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a9011b2e956bc24f8cdbe.jpg"
            afterImage="https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a900eb2e956bc24f8c77b.jpg"
          />
          <BeforeAfterSlider
            beforeImage="https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a9012109a1ab49dc13be4.jpg"
            afterImage="https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a900eee187be68947e273.jpg"
          />
          <BeforeAfterSlider
            beforeImage="https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a9012109a1ab49dc13c1e.jpg"
            afterImage="https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a90112ed3b9e323aa3c84.jpg"
          />
        </div>
      </div>
    </section>
  );
}
